module.exports = __webpack_public_path__ + "img/band-aid.eac59dbf.svg";